import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, IconButton, Menu, MenuItem, Tooltip } from "@common-ui/ui";
import Summarize from "@mui/icons-material/Summarize";

export const GenerateReportButton = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const router = useHistory();
  return (
    <Box>
      <Tooltip title="Generate Report" placement="left-end">
        <div>
          {/* <Button
            id="generate"
            size="small"
            variant="outlined"
            disabled={status !== "COMPLETED"}
            sx={{ fontWeight: 200 }}
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            Generate
          </Button> */}
          <IconButton
            disabled={props.workEvent?.length === 0}
            id="generate"
            size="small"
            variant="outlined"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            sx={{
              color: (theme) => theme.palette.grey[500],
              border: "1px solid grey",
              borderRadius: 2,
            }}
          >
            <Summarize fontSize="small" />
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              onClick={(e) => {
                router.push(
                  `/work-events/${props?.orgId}/work-event/${props?.workEvent?.id}/download`
                );
                handleClose(e);
              }}
            >
              Summary Report
            </MenuItem>
            <MenuItem
              disabled={props?.workEvent?.status !== "COMPLETED"}
              onClick={(e) => {
                router.push(
                  `/reports/performing_org/${props?.orgId}/workevent/${props?.workEvent?.id}`
                );
                handleClose(e);
              }}
            >
              Detailed Report
            </MenuItem>
          </Menu>
        </div>
      </Tooltip>
    </Box>
  );
};
